import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

type StatTileProps = {
  label: string
  value: ReactNode
  hint?: string
  emphasis?: boolean
  /** kpi: крупное число сверху (обзор); stat: подпись сверху, значение снизу (платежи, настройки) */
  variant?: 'kpi' | 'stat'
  cta?: ReactNode
  actionLabel?: string
  onAction?: () => void
  actionTo?: string
  className?: string
}

type StatTileRowProps = {
  children: ReactNode
  className?: string
  layout?: 'grid' | 'inline'
}

export const StatTileRow = ({ children, className, layout = 'grid' }: StatTileRowProps) => (
  <div
    className={[
      layout === 'inline' ? 'market-stat-tile-row market-stat-tile-row--inline' : 'market-stat-tile-row',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
  >
    {children}
  </div>
)

export const StatTile = ({
  label,
  value,
  hint,
  emphasis = false,
  variant = 'kpi',
  cta,
  actionLabel,
  onAction,
  actionTo,
  className,
}: StatTileProps) => {
  const action =
    cta ??
    (actionLabel && actionTo ? (
      <Link to={actionTo} className="echat-btn echat-btn--primary echat-btn--sm market-stat-tile__cta">
        {actionLabel}
      </Link>
    ) : actionLabel && onAction ? (
      <button
        type="button"
        className="echat-btn echat-btn--primary echat-btn--sm market-stat-tile__cta"
        onClick={onAction}
      >
        {actionLabel}
      </button>
    ) : null)

  return (
    <article
      className={[
        'market-stat-tile',
        variant === 'stat' ? 'market-stat-tile--stat' : '',
        emphasis ? 'market-stat-tile--emphasis' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {variant === 'stat' ? (
        <>
          <p className="market-stat-tile__label">{label}</p>
          <p className="market-stat-tile__value">{value}</p>
        </>
      ) : (
        <>
          <p className="market-stat-tile__value">{value}</p>
          <p className="market-stat-tile__label">{label}</p>
        </>
      )}
      {hint ? <p className="market-stat-tile__hint">{hint}</p> : null}
      {action}
    </article>
  )
}
